<template>
    <div class="container">
        <div class="col-md-12">
            <h3><b><i>{{ f_titulo() }}</i></b></h3>
        </div>
        <b-container>
            <b-row class="mb-4 align-items-center text-lg">
                <!-- Vigencia -->
                <b-col md="4">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.vigencia }}</b></label>
                    <input type="month" v-model="selVigencia" class="form-control form-control-lg">
                </b-col>

                <!-- Grupo -->
                <b-col md="4">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.group }}</b></label>
                    <select v-model="grupoId" @change="f_filterCompany" class="form-control form-control-lg">
                        <option value="">Todos los grupos</option>
                        <option v-for="grupo in listGrupos" :key="grupo.id" :value="grupo.id">
                            {{ grupo.nombre }}
                        </option>
                    </select>
                </b-col>

                <!-- Compañía -->
                <b-col md="4">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.company }}</b></label>
                    <select v-model="companyId" @change="f_valide_formato" class="form-control form-control-lg">
                        <option value="">{{ labels.seleccione }}</option>
                        <option v-for="company in filteredCompany" :key="company.id" :value="company.id">
                            {{ company.acronym }} {{ company.nombre }}
                        </option>
                    </select>
                </b-col>
            </b-row>
            <b-row v-if="selVigencia && companyId && currencyCTA" class="mb-4 align-items-center text-lg">
		<b-col>
		<b-button @click="f_calcula_cta()" id="consult-btn">{{ labels.calculeCTA }}</b-button>
		</b-col>
            </b-row>

            <b-row v-if="selVigencia && companyId && formato_asignado" class="mb-4 align-items-center text-lg">
                <b-col md="6">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>Archivo Excel</b></label>
                    <input id="archivoExcel" type="file" @change="cargaExcel()" class="form-control form-control-lg">
                </b-col>

                <b-col v-if="muestraHoja" md="6">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.hoja }}</b></label>
                    <select v-model="selectedHoja" @change="f_showHoja()" class="form-control form-control-lg">
                        <option value="">{{ labels.seleccione }}</option>
                        <option v-for="(item, idx) in listHojas" :value="item" :key="idx">{{ item }}</option>
                    </select>
                </b-col>
            </b-row>
        </b-container>
        <div class="col-md-1"></div>
        <div v-if="showBtnHoja == true" class="col-md-12 row justify-content-center mt-4">
            <b-button @click="cargaBalanceSeleccionado()" id="consult-btn">{{ labels.chargeHoja }}</b-button>
        </div>
        <div v-if="!isLoading"></div>
        <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner></b-spinner>
        </div>
    </div>
</template>

<script>
import Company from "../../services/Company"
import Cargue from "../../services/Cargue";
import * as XLSX from "xlsx"
import Grupo from "../../services/Grupo"  // Importar servicio de grupos

export default {
    name: "CargueBalance",
    data: () => ({
        listGrupos: [],           // Lista de grupos
        grupoId: "",              // ID del grupo seleccionado
        filteredCompany: [],      // Compañías filtradas por grupo
        listCompany: [],          // Todas las compañías
        listVigencia: [],
        companyId: "",
        selVigencia: "",
        formato_asignado: false,
        listCuenta: [],
        listHojas: [],
        showBtnHoja: false,
        isLoading: false,
        inputArch: "",
        workbook: "",
        muestraHoja: false,
        selHoja: false,
        selectedHoja: '',
        fileReader: '',
        formato: '',
	currencyCTA: false,
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "CARGUE BALANCE FORMATO EXCEL SIN INFORMACION NIIF",
                    company: "Compañía:",
                    group: "Grupo",  // Nuevo label para grupo
                    vigencia: "Vigencia:",
                    charge: "Cargar",
                    chargeHoja: "Cargar Hoja",
                    calculeCTA: "Currency Traslate Adjustment",
                    seleccione: "Seleccione.....",
                    hoja: "Hoja"
                }
            } else {
                return {
                    title: "LOAD BALANCE SHEET EXCEL FORMAT WITHOUT NIIF INFORMATION",
                    company: "Company:",
                    group: "Group",  // Nuevo label para grupo
                    vigencia: "Validity:",
                    charge: "Charge",
                    calculeCTA: "Currency Traslate Adjustment",
                    chargeHoja: "Charge Sheet",
                    seleccione: "Select.....",
                    hoja: "Sheet"
                }
            }
        }
    },
    methods: {
        f_titulo() {
            let titulo = ""
            let tituloEN = ""
            titulo = "PROCESO DE CARGUE DE BALANCES"
            tituloEN = "ACCOUNTING BALANCE UPLOAD PROCESS"
            if (this.$store.state._language != "es-ES") {
                titulo = tituloEN
            }
            if (this.formato) {
                titulo = this.f_titulo_cargue()
            }
            return titulo
        },

        // MÉTODO NUEVO: Filtrar compañías por grupo
        f_filterCompany() {
            console.log('=== INICIO FILTRO ===');
            console.log('Grupo seleccionado (ID):', this.grupoId);

            if (this.grupoId) {
                const grupoIdNum = this.grupoId.toString(); // Convertir a string para comparar

                // Encontrar el grupo seleccionado para mostrar su nombre
                const grupoSeleccionado = this.listGrupos.find(g => g.id === parseInt(grupoIdNum));
                console.log('Grupo seleccionado (Objeto):', grupoSeleccionado);

                // Filtrar compañías - BUSCAR EN EL STRING
                this.filteredCompany = this.listCompany.filter(company => {
                    if (!company.id_grupos) return false;

                    const gruposCompania = company.id_grupos
                        .split(',')
                        .map(id => id.trim());

                    const coincide = gruposCompania.includes(grupoIdNum);
                    console.log(`Compañía: ${company.nombre}, id_grupos: ${company.id_grupos}, Coincide: ${coincide}`);
                    return coincide;
                });

                console.log('Resultado del filtro:', this.filteredCompany.map(c => c.nombre));
            } else {
                console.log('Mostrando TODAS las compañías');
                this.filteredCompany = this.listCompany;
            }

            this.companyId = "";
            this.formato_asignado = false;
            console.log('=== FIN FILTRO ===');
        },

        f_titulo_cargue() {
            let titulo = ""
            let tituloEN = ""
            switch (this.formato) {
                case 1:
                    titulo = "CARGUE BALANCE EXCEL UNIVERSIDAD EL BOSQUE"
                    tituloEN = "LOAD BALANCE SHEET EXCEL UNIVERSIDAD EL BOSQUE"
                    break;
                case 2:
                    titulo = "CARGUE BALANCE EXCEL IPS EL BOSQUE"
                    tituloEN = "LOAD BALANCE EXCEL IPS EL BOSQUE"
                    break;
                case 3:
                    titulo = "CARGUE BALANCE FORMATO 3"
                    tituloEN = "LOAD BALANCE SHEET FORMAT 3"
                    break;
                case 4:
                    titulo = "CARGUE BALANCE FORMATO 4"
                    tituloEN = "LOAD BALANCE SHEET FORMAT 4"
                    break;
                case 5:
                    titulo = "CARGUE BALANCE FORMATO 5"
                    tituloEN = "LOAD BALANCE SHEET FORMAT 5"
                    break;
                case 6:
                    titulo = "CARGUE BALANCE FORMATO 6"
                    tituloEN = "LOAD BALANCE SHEET FORMAT 6"
                    break;
            }
            if (this.$store.state._language != "es-ES") {
                titulo = tituloEN
            }
            return titulo
        },
        f_calcula_cta() {
		const selVigencia=this.selVigencia.replace("-","")
		const companyId=this.companyId
		this.selVigencia=''
		this.companyId=''
		this.formato_asignado=false	
		let v_error = false
		Cargue.calculaCTA(selVigencia,companyId,this.$store.state.userId)
		.then((res) => {
			if	(res.status !== 200) {
				v_error = false
			} else {
				v_error = true
			}
		})
		if	(v_error) {
			this.$toast.error("Problema al generar CTA")
		} else {
			this.$toast.success("CTA Generado")
		}
	},
        cargaExcel() {
            this.showBtnHoja = false
            this.muestraHoja = false
            this.selHoja = false
            this.selectedHoja = false
            const inputArch = document.getElementById("archivoExcel")
            var selectedFile = inputArch.files[0]
            this.fileReader = new FileReader();
            this.fileReader.onload = function (event) {
                var data = event.target.result
                this.workbook = XLSX.read(data, { type: "binary" })
                let hojas = this.workbook.SheetNames
                this.listHojas = hojas
            };
            if (selectedFile) {
                this.fileReader.readAsBinaryString(selectedFile)
                setTimeout(() => {
                    this.muestraHoja = true
                    this.listHojas = this.fileReader.listHojas
                }, 2000)
            }
        },
        cargaBalanceSeleccionado() {
            let rowObject = XLSX.utils.sheet_to_row_object_array(
                this.fileReader.workbook.Sheets[this.selectedHoja])
            this.listCuenta = []
            rowObject.forEach(fila => {
                var columnas = Object.values(fila)
                this.listCuenta.push(columnas)
            })
            let form = {
                "vigencia": this.cambFormatoVigencia(),
                "company": this.companyId,
                "listadoCuentas": this.listCuenta,
                'idUser': this.$store.state.userId
            }
            let v_error = false
            switch (this.formato) {
                case 1:
                    Cargue.cargaBalace(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 2:
                    Cargue.cargaBalaceF2(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 3:
                    Cargue.cargaBalaceF3(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 4:
                    Cargue.cargaBalaceF4(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 5:
                    Cargue.cargaBalaceF5(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 6:
                    Cargue.cargaBalaceF6(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 7:
                    Cargue.cargaBalaceF7(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 8:
                    Cargue.cargaBalaceF8(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 9:
                    Cargue.cargaBalaceF9(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 10:
                    Cargue.cargaBalaceF10(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 100:
                    Cargue.cargaBalaceF100(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 200:
                    Cargue.cargaBalaceF200(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 300:
                    Cargue.cargaBalaceF300(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 400:
                    Cargue.cargaBalaceF400(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 500:
                    Cargue.cargaBalaceF500(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
                case 600:
                    Cargue.cargaBalaceF600(form)
                        .then((res) => {
                            if (res.status !== 200) {
                                v_error = false
                            } else {
                                v_error = true
                            }
                        })
                    if (v_error) {
                        this.$toast.error("Problema al Cargar")
                    } else {
                        setTimeout(() => {
                            this.actualizaNiif(form.vigencia, form.company)
                            this.resetForm();
                        }, 10000)
                    }
                    break;
            }
            if (!v_error) {
                this.showBtnHoja = false
            }
        },
        actualizaNiif(p_vigencia, p_compania) {
            Cargue.actualizaNiif(p_vigencia, p_compania)
                .then((res) => {
                    if (res.status === 200) {
                        this.$toast.success("Cargue Completo")
                        this.resetForm(); 
                    } else {
                        this.$toast.error("Error(1) al Actualizar Niif(Cargue)")
                    }
                })
                .catch(() => {
                    this.$toast.error("Error(2) al Actualizar Niif(Cargue) ")
                })
        },
        cambFormatoVigencia() {
            let anio = this.selVigencia.substring(0, 4)
            let mes = this.selVigencia.substring(5, 7)
            let newMes = mes

            return anio + newMes
        },
        f_showHoja() {
            this.showBtnHoja = true
        },
        f_valide_formato() {
		this.currencyCTA=false
		this.formato_asignado = false
		let objFormato = this.listCompany.find((obj) => obj.id === this.companyId)
		this.formato = objFormato.formato
		if (this.formato) {
			this.formato_asignado = true
			if	(objFormato.id_moneda != 2) {
				this.currencyCTA = true
			}
		} else {
			this.$toast.success(objFormato.nombre + " sin formato asignado")
		}
        },
        resetForm() {
            this.grupoId = "";
            this.companyId = "";
            this.selVigencia = "";
            this.formato_asignado = false;
            this.listHojas = [];
            this.showBtnHoja = false;
            this.muestraHoja = false;
            this.selectedHoja = '';
            this.formato = '';

            // Limpiar el input de archivo
            const inputArch = document.getElementById("archivoExcel");
            if (inputArch) {
                inputArch.value = "";
            }

            // Resetear filteredCompany para mostrar todas las compañías
            this.filteredCompany = this.listCompany;
        },
    },
    mounted() {
        this.isLoading = true;

        Grupo.getAllGrupos()
            .then((result) => {
                this.listGrupos = result.data.grupos;
                console.log('Grupos cargados:', this.listGrupos);
                return Company.getAllCompanies();
            })
            .then((result) => {
                // ¡CORRECCIÓN AQUÍ! Usar result.data.companies (con "s")
                this.listCompany = result.data.companies;
                console.log('Compañías cargadas:', this.listCompany);

                // Verificar si tenemos el campo id_grupos
                if (this.listCompany.length > 0) {
                    const primeraCompany = this.listCompany[0];
                    console.log('Primera compañía:', primeraCompany);
                    console.log('Tiene id_grupos?', 'id_grupos' in primeraCompany);
                    console.log('Valor de id_grupos:', primeraCompany.id_grupos);
                    console.log('Nombre del grupo:', primeraCompany.grupo_nombre);
                }

                this.filteredCompany = this.listCompany;
                return Cargue.getVigenciaCargue();
            })
            .then((res) => {
                this.listVigencia = res.data.getVigencia;
            })
            .catch((err) => {
                console.log(err);
                this.$toast.error('Error al cargar datos');
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}
</script>
<style src="../main.css"></style>
